import { render, staticRenderFns } from "./DashboardActivityLog.vue?vue&type=template&id=b2b25318&"
import script from "./DashboardActivityLog.vue?vue&type=script&lang=js&"
export * from "./DashboardActivityLog.vue?vue&type=script&lang=js&"
import style0 from "./DashboardActivityLog.vue?vue&type=style&index=0&id=b2b25318&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports